module.exports = __webpack_public_path__ + "img/made-in-france.c010ac15.png";